// Librerías
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { loginUser, cleanRedirectUser } from "../../store/user/actions";
import AxiosAuth from "../../services/requestApi";
import { BASE_URL } from "../../Helpers";
import ModalWrapper from "../../components/Modals/ModalWrapper";
import HostFreeNoticeModal from "../../components/Modals/HostFreeNoticeModal";

const SocialLoginContainer = ({ redirectUrl, children }) => {
  const dispatch = useDispatch();
  const loginState = useSelector((state) => state.userReducer, shallowEqual);
  const query = queryString.parse(window.location.search);
  const history = useHistory();
  const [showHostNoticeModal, setShowHostNoticeModal] = useState(false);
  const [hostNoticeName, setHostNoticeName] = useState("");
  const [pendingRedirectPath, setPendingRedirectPath] = useState("/");
  const [callbackHandled, setCallbackHandled] = useState(false);

  const getRedirectPath = () => (loginState.redirect ? loginState.redirect : "/");

  const redirectAfterLogin = (redirectPath) => {
    if (loginState.redirect) {
      dispatch(cleanRedirectUser());
    }
    history.push(redirectPath);
  };

  const hasActivePublishedHousing = async () => {
    try {
      const url = `${BASE_URL}/housing/my`;
      const response = await AxiosAuth.get(url);
      return (
        Array.isArray(response.data) &&
        response.data.some((housing) => housing && housing.public)
      );
    } catch (e) {
      return false;
    }
  };

  const runPostLoginFlow = async (firstName) => {
    const redirectPath = getRedirectPath();
    const shouldShowHostNotice = await hasActivePublishedHousing();

    if (shouldShowHostNotice) {
      if (loginState.redirect) {
        dispatch(cleanRedirectUser());
      }
      setPendingRedirectPath(redirectPath);
      setHostNoticeName(firstName || "");
      setShowHostNoticeModal(true);
      return;
    }

    redirectAfterLogin(redirectPath);
  };

  const handleCloseHostNotice = () => {
    setShowHostNoticeModal(false);
    history.push(pendingRedirectPath || "/");
  };

  useEffect(() => {
    /* Social login callback*/
    const { token, refresh_token, firstName, lastName, avatar, id, email } = query;

    const handleSocialCallback = async () => {
      if (callbackHandled) {
        return;
      }

      if (token && refresh_token && firstName && lastName && avatar && id) {
        localStorage.setItem("token", token);
        localStorage.setItem("refresh_token", refresh_token);
        localStorage.setItem(
          "userData",
          JSON.stringify({
            token: token,
            refresh_token: refresh_token,
            avatar: avatar,
            firstName: firstName,
            lastName: lastName,
            login: true,
            id: id,
          })
        );

        dispatch(
          loginUser({
            token,
            refresh_token,
            firstName,
            lastName,
            avatar,
            id,
            email,
          })
        );

        setCallbackHandled(true);
        await runPostLoginFlow(firstName);
      }
    };

    handleSocialCallback();
  }, [query, dispatch, loginState.redirect, history, callbackHandled]);

  const handleSocialLogin = () => {
    if (redirectUrl) {
      // Redirigir a la URL del proveedor de social login
      window.location.href = redirectUrl;
    }
  };

  return (
    <div onClick={handleSocialLogin}>
      {children}
      {showHostNoticeModal ? (
        <HostFreeNoticeModal
          firstName={hostNoticeName}
          onClose={handleCloseHostNotice}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default SocialLoginContainer;
